
// "use client";

// import React, { useEffect, useRef } from "react";
// import { useForm, SubmitHandler } from "react-hook-form";
// import { useNavigate, useLocation } from "react-router-dom";
// import { auth } from "../config/firebase";
// import {
//   signInWithEmailAndPassword,
//   signInWithRedirect,
//   GoogleAuthProvider,
//   OAuthProvider,
//   getRedirectResult,
//   onAuthStateChanged,
// } from "firebase/auth";
// import {
//   Button,
//   TextField,
//   Typography,
//   Grid,
//   Card,
//   Link as MuiLink,
// } from "@mui/material";
// import { useTranslation } from "react-i18next";

// type Inputs = {
//   email: string;
//   password: string;
// };

// export const Login = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { t } = useTranslation();
//   const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

//   const searchParams = new URLSearchParams(location.search);
//   const redirectPath = searchParams.get("redirect");
//   const reason = searchParams.get("reason");

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm<Inputs>();


//   const shownRef = useRef(false);
//   useEffect(() => {
//     if (reason === "auth_required" && !shownRef.current) {
//       alert("このサービスを利用するにはログインが必要です。サインインが未だの方は先に会員登録ください。");
//       shownRef.current = true;
//     }
//   }, [reason]);
  
//   useEffect(() => {
//     getRedirectResult(auth)
//       .then((result) => {
//         if (result) {
//           navigate(redirectPath || "/");
//         }
//       })
//       .catch((error) => {
//         alert(`認証エラー: ${error.message}`);
//       });
//   }, [navigate, redirectPath]);
//   // Emailログイン
//   const onSubmit: SubmitHandler<Inputs> = async (data) => {
//     try {
//       await signInWithEmailAndPassword(auth, data.email, data.password);
//       navigate(redirectPath || "/");
//     } catch (error: any) {
//       console.error(error);
//       alert(error.message);
//     }
//   };

//   // Googleログイン
//   const googleAuth = () => {
//     const provider = new GoogleAuthProvider();
//     if (googleClientId) {
//       provider.setCustomParameters({ client_id: googleClientId });
//     }
//     signInWithRedirect(auth, provider);
//   };

//   // LINEログイン（OIDC連携）
//   const lineAuth = () => {
//     const provider = new OAuthProvider("oidc.line");
//     signInWithRedirect(auth, provider);
//   };

//   return (
//     <Grid
//       container
//       justifyContent="center"
//       alignItems="center"
//       style={{ minHeight: "100vh", backgroundColor: "#f0f0f0" }}
//     >
//       <Card
//         style={{
//           padding: "20px",
//           borderRadius: "10px",
//           boxShadow: "0 0 10px rgba(0,0,0,0.1)",
//           width: "100%",
//           maxWidth: "500px",
//         }}
//       >
//         <Grid item xs={12}>
//           <Typography variant="h5" align="center" gutterBottom>
//             {t("login")}
//           </Typography>

//           {/* Googleログイン */}
//           <Button
//             fullWidth
//             variant="outlined"
//             onClick={googleAuth}
//             style={{ marginBottom: "10px" }}
//           >
//             {t("login_with_google")}
//           </Button>


//           <form onSubmit={handleSubmit(onSubmit)}>
//             <TextField
//               variant="outlined"
//               margin="normal"
//               fullWidth
//               label={t("email_address")}
//               autoComplete="email"
//               {...register("email", { required: t("email_is_required") })}
//               error={Boolean(errors.email)}
//               helperText={errors.email?.message}
//             />
//             <TextField
//               variant="outlined"
//               margin="normal"
//               fullWidth
//               label={t("password")}
//               type="password"
//               autoComplete="current-password"
//               {...register("password", {
//                 required: t("password_is_required"),
//                 minLength: {
//                   value: 6,
//                   message: "パスワードは6文字以上です。",
//                 },
//               })}
//               error={Boolean(errors.password)}
//               helperText={errors.password?.message}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               color="primary"
//               style={{ marginTop: "20px", marginBottom: "20px" }}
//             >
//               {t("login")}
//             </Button>
//           </form>

//           <Grid container direction="column" spacing={1}>
//             <Grid item>
//               <Typography variant="body1">
//                 アカウントをお持ちでない方はこちら👉
//                 <MuiLink href="/settings/register" style={{ textDecoration: "none" }}>
//                   会員登録へ
//                 </MuiLink>
//               </Typography>
//             </Grid>
//             <Grid item>
//               <MuiLink href="/settings/forgot-password" variant="body2">
//                 {t("forgot_password")}
//               </MuiLink>
//             </Grid>
//             <Grid item>
//               <Typography variant="body2">
//                 このアプリのGoogle APIから受け取った情報の使用および他のアプリへの転送は、Google APIサービスユーザーデータポリシー、含む利用限定要件に従います。
//               </Typography>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Card>
//     </Grid>
//   );
// };
import React, { useEffect, useRef } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../config/firebase";
import {
  signInWithEmailAndPassword,
  signInWithRedirect,
  GoogleAuthProvider,
  OAuthProvider,
  getRedirectResult,
} from "firebase/auth";
import {
  Button,
  TextField,
  Typography,
  Grid,
  Card,
  Link as MuiLink,
} from "@mui/material";
import { useTranslation } from "react-i18next";

// 型定義
type Inputs = {
  email: string;
  password: string;
};

export const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  const searchParams = new URLSearchParams(location.search);
  const redirectPath = searchParams.get("redirect");
  const reason = searchParams.get("reason");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const shownRef = useRef(false);

  useEffect(() => {
    if (reason === "auth_required" && !shownRef.current) {
      alert(
        "このサービスを利用するにはログインが必要です。サインインが未だの方は先に会員登録ください。"
      );
      shownRef.current = true;
    }
  }, [reason]);

  useEffect(() => {
    getRedirectResult(auth)
      .then((result) => {
        if (result) {
          navigate(redirectPath || "/");
        }
      })
      .catch((error) => {
        alert(`認証エラー: ${error.message}`);
      });
  }, [navigate, redirectPath]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      await signInWithEmailAndPassword(auth, data.email, data.password);
      navigate(redirectPath || "/");
    } catch (error: any) {
      console.error(error);
      alert(error.message);
    }
  };

  const googleAuth = () => {
    const provider = new GoogleAuthProvider();
    if (googleClientId) {
      provider.setCustomParameters({ client_id: googleClientId });
    }
    signInWithRedirect(auth, provider);
  };

  const lineAuth = () => {
    const provider = new OAuthProvider("oidc.line");
    signInWithRedirect(auth, provider);
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: "100vh", backgroundColor: "#e5e5e5", padding: "24px" }}
    >
      <Card
        style={{
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          backgroundColor: "#ffffff",
          width: "100%",
          maxWidth: "480px",
        }}
      >
        <Grid container spacing={2} direction="column">
          <Grid item>
            <Typography variant="h5" align="center" gutterBottom>
              {t("login")}
            </Typography>
          </Grid>

          <Grid item>
            <Button
              fullWidth
              variant="outlined"
              onClick={googleAuth}
              style={{
                marginBottom: "16px",
                padding: 0,
                border: "none",
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <img
                src="/images/web_dark_rd_SI@3x.png"
                alt="Sign in with Google"
                style={{
                  width: "100%",
                  maxWidth: "320px",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </Button>
          </Grid>

          <Grid item>
            <form onSubmit={handleSubmit(onSubmit)}>
              <TextField
                fullWidth
                label={t("email_address")}
                variant="outlined"
                margin="dense"
                autoComplete="email"
                {...register("email", { required: t("email_is_required") })}
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
              <TextField
                fullWidth
                label={t("password")}
                type="password"
                variant="outlined"
                margin="dense"
                autoComplete="current-password"
                {...register("password", {
                  required: t("password_is_required"),
                  minLength: {
                    value: 6,
                    message: "パスワードは6文字以上です。",
                  },
                })}
                error={Boolean(errors.password)}
                helperText={errors.password?.message}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: "20px" }}
              >
                {t("login")}
              </Button>
            </form>
          </Grid>

          <Grid item>
            <Typography variant="body1">
              アカウントをお持ちでない方はこちら👉
              <MuiLink href="/settings/register" style={{ textDecoration: "none" }}>
                会員登録へ
              </MuiLink>
            </Typography>
          </Grid>
          <Grid item>
            <MuiLink href="/settings/forgot-password" variant="body2">
              {t("forgot_password")}
            </MuiLink>
          </Grid>
          <Grid item>
            <Typography variant="body2">
              このアプリのGoogle APIから受け取った情報の使用および他のアプリへの転送は、
              Google APIサービスユーザーデータポリシー、含む利用限定要件に従います。
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};